/* global fetch */
import Store from 'store/store'

import Papa from 'papaparse'
import { render } from 'utils/jsx'
import ip from 'utils/ip'

import moment from 'moment'
import App from 'components/App'

moment.locale('fr')

;(async () => {
  try {
    // TODO: handle no url
    const url = window.ENV.production
      ? window.location.hash
        ? `https://logs.tooooools.com/logs/${window.location.hash.substring(1)}.csv`
        : `https://logs.tooooools.com/logs/tooooools-${window.location.pathname.replace(/\//g, '')}.csv`
      : 'dummy.csv'

    const response = await fetch(url)
    if (!response.ok) {
      console.log(response)
      throw new Error(`[${response.status}] ${response.statusText}`)
    }

    Store.ip.set(await ip())

    Store.url.set(url)
    const csv = await response.text()

    const { data } = Papa.parse(csv.trim(), { header: true })
    Store.log.set(data.map(event => {
      event.date = new Date(event.date)
      event.data = JSON.parse(event.data)
      return event
    }))

    render(<App />, document.body)
  } catch (error) {
    console.error(error)
    render(<div class='loading-error'>{error.message}</div>, document.body)
  } finally {
    document.body.classList.remove('is-loading')
  }
})()



// WEBPACK FOOTER //
// ./src/index.js